<script setup lang="ts">
const { t } = useI18n();
</script>

<template>
  <div class="about-section">
    <div class="about-section__item _text">
      <h1 class="about-section__title">
        {{ t('forBusinessPage.aboutSectionTitle') }}
      </h1>
      <div class="about-section__text">
        {{ t('aboutCompanyDescription') }}
      </div>
    </div>
    <div class="about-section__item">
      <NuxtImg
        src="/images/logo.webp"
        :alt="t('aboutCompany')"
        class="about-section__logo"
      />
    </div>
  </div>
</template>

<style lang="less">
.about-section {
  display: flex;
  align-items: center;
  gap: 132px;

  &__item {
    &._text {
      .flex-column(@size-x6);

      max-width: 820px;
    }
  }

  &__logo {
    width: 425px;
    height: 123px;
  }

  &__title {
    .h-offset-reset();

    font-size: 48px;
    font-weight: 500;
    line-height: 115%;
  }

  &__text {
    font-size: 18px;
    font-weight: 400;
    line-height: 150%;
    color: @color-dove-gray-secondary;
  }

  @media @1024 {
    flex-direction: column;
    gap: @size-x5;
    margin-bottom: @size-x5;

    &__item {
      &._text {
        gap: @size-x3;
      }
    }

    &__title {
      font-size: @size-x6;
    }

    &__text {
      font-size: 14px;
      line-height: 130%;
    }

    &__logo {
      width: 225px;
      height: 65px;
    }
  }
}
</style>
